import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'
import Link from 'next/link'
import styles from './styles'

export default function SimplePlayerBanner({ usedTrial, bannerData, imageView }) {
  const data = {
    backgroundWeb: bannerData?.desktopBanner?.data?.attributes?.url,
    backgroundMobile: bannerData?.mobileBanner?.data?.attributes?.url,
    buttonLink: bannerData?.bannerLink,
  }

  // Let's do some deeper validation - desktop&mobile images are required
  if (!bannerData?.desktopBanner?.data) return null
  if (!bannerData?.mobileBanner?.data) return null

  const banner = (
    <div className="SimplePlayerBanner">
      <Image
        src={imageView ? data?.backgroundMobile : data?.backgroundWeb}
        className="SimplePlayerBannerImage"
        alt="Player Promo Banner"
        fill={false}
        width={1200}
        height={120}
        layout="responsive"
      />
    </div>
  )

  return (
    <>
      {data?.buttonLink && <Link href={data?.buttonLink}>{banner}</Link>}
      {!data?.buttonLink && (<>{banner}</>)}
      <style jsx>{styles}</style>
    </>
  )
}

SimplePlayerBanner.propTypes = {
  usedTrial: PropTypes.bool,
  bannerData: PropTypes.shape({
    desktopBanner: PropTypes.object,
    mobileBanner: PropTypes.object,
    bannerLink: PropTypes.string,
  }),
  imageView: PropTypes.bool,
}

SimplePlayerBanner.defaultProps = {
  bannerData: {
    background: '',
    buttonLink: '',
  },
  imageView: false,
  usedTrial: false,
}
